import { render, staticRenderFns } from "./WRadioGroup.vue?vue&type=template&id=0d1ef056&scoped=true&"
import script from "./WRadioGroup.vue?vue&type=script&lang=js&"
export * from "./WRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./WRadioGroup.vue?vue&type=style&index=0&id=0d1ef056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1ef056",
  null
  
)

export default component.exports